import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	errorMessage: {
		id: 'issue-comment-base.comment.comment-visibility.error-image.error-message',
		defaultMessage: "We couldn't load the visibility options",
		description: 'Text that is shown when there is an error fetching comment visibility options',
	},
});
